export default function datepickerConfig(uibDatepickerConfig) {
	uibDatepickerConfig.showWeeks = false;
}
